import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: 24,
    paddingBottom: 24,
  },
  breadCrumbs: {
    marginBottom: 0,
  },
  headerRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 16,
  },
  heading: {
    fontFamily: 'Readex Pro',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '32px',
    letterSpacing: '0.96px',
    color: Colors.Grey10,
  },
  tabsRow: {
    marginTop: 13,
    borderBottom: `1px solid ${Colors.Grey3}`,
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingRight: 40,
  },
  tabs: {
    minHeight: 48,
  },
  tab: {
    textTransform: 'none',
    fontFamily: 'Readex Pro',
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.64px',
    fontWeight: 200,
    color: Colors.Grey6,
    minHeight: 48,
    padding: '12px 0',
    marginRight: 32,
  },
  tabIndicator: {
    backgroundColor: Colors.Grey10,
    height: 2,
  },
  filtersRow: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    height: 48,
  },
  smallButton: {
    border: `1px solid ${Colors.Black}`,
    borderRadius: 0,
    padding: '4px 8px',
    minHeight: 'auto',
    '&.Mui-disabled': {
      opacity: 1,
      color: Colors.Black,
      border: `1px solid ${Colors.Black}`,
    },
  },
  smallIcon: {
    width: 20,
    height: 20,
    marginRight: 4,
  },
  smallSelect: {
    fontFamily: 'Readex Pro',
    fontSize: 14,
    minWidth: 140,
    '& .MuiSelect-select': {
      padding: '4px 8px',
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: Colors.Black,
      borderRadius: 0,
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
  },
}));

export default useStyles;
